import React from 'react'

const TitleBar = ({ title, color }) => {
    return (
        <>
            <div style={{clear:'both'}}></div>
            <div 
                style={{
                    fontSize:'14px',
                    textAlign:'left', 
                    backgroundColor:color || '#305496', 
                    color:'#fff', 
                    marginLeft:'0px', 
                    marginTop:'5px', 
                    marginRight:'0px', 
                    marginBottom:'5px', 
                    padding:'3px', 
                    borderRadius:'5px'
                }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{ title }
            </div>
        </>
    )
  }
  
  export default TitleBar